import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
  constructor(public jwtHelper: JwtHelperService) {}
  // ...

  public getToken(){
    console.log("token", localStorage.getItem('token'))
      return localStorage.getItem('token');
  }
  public isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    console.error("TOKEN", token)
    // Check whether the token is expired and return
    // true or false
    return !this.jwtHelper.isTokenExpired(token);
  }
}
